import type { KeywordFilterData } from '@hotjar/feedback';

import { KeywordFilter as BaseKeywordFilter } from '@hotjar/feedback/components/common/Responses/Filters/KeywordFilter/KeywordFilter';
import type { KeywordResponseFilterValue } from '@hotjar/global-filters';

import { useCallback } from 'react';
import type { ChangeFilter, RemoveFilter } from './FilterTypes';

export const KeywordFilter = ({
  filter,
  onChange,
  onRemove,
  isDisabled,
  disabledReason,
}: {
  filter: KeywordFilterData;
  onChange: ChangeFilter<KeywordFilterData>;
  onRemove: RemoveFilter<KeywordFilterData>;
  isDisabled?: boolean;
  disabledReason?: string;
}): JSX.Element => {
  const onApply = useCallback(
    (newValue: KeywordResponseFilterValue) => {
      onChange(filter, newValue);
    },
    [onChange, filter],
  );

  const onRemoveFilter = useCallback(() => {
    onRemove(filter);
  }, [onRemove, filter]);

  return (
    <BaseKeywordFilter
      currentValue={filter.value}
      onApply={onApply}
      onRemove={filter.value !== undefined ? onRemoveFilter : undefined}
      isInactive={filter.value === undefined}
      isDisabled={isDisabled}
      disabledReason={disabledReason}
    />
  );
};
